import { TestIds } from '@/core/constants/test-ids';
import { Link as MaterialLink, LinkProps as MaterialLinkProps } from '@mui/material';
import NextLink, { LinkProps } from 'next/link';
import { isNil } from 'ramda';
import { FC, ReactNode } from 'react';

type HBLinkProps = Omit<MaterialLinkProps, 'href'> &
  Pick<LinkProps, 'locale' | 'passHref' | 'shallow'> & {
    href?: LinkProps['href'];
    textDecoration?: 'none' | 'underline';
    width?: string | number;
  };

const NextCustomLink = ({
  href,
  textDecoration = 'none',
  width,
  children,
  target,
  ...props
}: Partial<LinkProps> & {
  children?: ReactNode;
  textDecoration?: 'none' | 'underline';
  width?: string | number;
  target?: string;
}): JSX.Element => {
  const isLink = !isNil(href);
  if (!isLink) {
    return children as JSX.Element;
  }
  return (
    <NextLink
      style={{ textDecoration, width }}
      data-test-id={TestIds.core.linkTestId}
      target={target}
      {...props}
      {...{ href, children }}
    />
  );
};

export const HBLink: FC<HBLinkProps> = ({
  href,
  passHref = true,
  shallow,
  textDecoration = 'none',
  width,
  target,
  ...materialLinkProps
}) => {
  return (
    <NextCustomLink
      {...{
        href,
        passHref,
        shallow,
        textDecoration,
        width,
        target,
      }}
    >
      <MaterialLink
        underline="always"
        style={{ cursor: 'pointer', textDecoration }}
        target={target}
        {...materialLinkProps}
      />
    </NextCustomLink>
  );
};
